import { Col, Container, Row } from 'darrius';

const Root = ({ children }) => {
  return <Container>{children}</Container>;
};

const Header = ({ children }) => {
  return (
    <Row className="center-sm">
      <Col className="col-sm-12 col-md-6">{children}</Col>
    </Row>
  );
};

const Body = ({ children, className = null }) => {
  return (
    <Row className={className}>
      <Col className="col-sm-12 col-md-6 col-md-offset-3">{children}</Col>
    </Row>
  );
};

const Actions = ({ children }) => {
  return <>{children}</>;
};

export { Root, Header, Body, Actions };
